"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropertyStatusForType = exports.default = void 0;
var _values = _interopRequireDefault(require("lodash/values"));
var _listingType = _interopRequireWildcard(require("./listing-type"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var PropertyStatus = {
  FOR_SALE: {
    name: 'FOR_SALE',
    residentialLabel: 'For Sale',
    commercialLabel: 'For Sale',
    digitalDataKey: 'For Sale',
    urlSlug: 'for-sale',
    listingTypes: [..._listingType.SaleListingTypeNames, _listingType.default.DEVELOPMENTS_RESIDENTIAL.name]
  },
  UNDER_OFFER: {
    name: 'UNDER_OFFER',
    residentialLabel: 'Under Offer',
    commercialLabel: 'Under Offer',
    digitalDataKey: 'Under Offer',
    urlSlug: 'under-offer',
    listingTypes: [..._listingType.SaleListingTypeNames, _listingType.default.DEVELOPMENTS_RESIDENTIAL.name]
  },
  SOLD: {
    name: 'SOLD',
    residentialLabel: 'Include sold (last %LISTING_VISIBILITY%)',
    commercialLabel: 'Include sold (last %LISTING_VISIBILITY%)',
    digitalDataKey: 'Sold',
    urlSlug: 'sold',
    listingTypes: [..._listingType.SaleListingTypeNames, _listingType.default.DEVELOPMENTS_RESIDENTIAL.name]
  },
  AVAILABLE_FOR_RENT: {
    name: 'AVAILABLE_FOR_RENT',
    residentialLabel: 'For Rent',
    commercialLabel: 'For Lease',
    digitalDataKey: 'For Rent',
    urlSlug: 'for-rent',
    listingTypes: _listingType.RentListingTypeNames
  },
  UNDER_APPLICATION: {
    name: 'UNDER_APPLICATION',
    residentialLabel: 'Under Application',
    commercialLabel: 'Under Application',
    digitalDataKey: 'Under Application',
    urlSlug: 'under-application',
    listingTypes: _listingType.RentListingTypeNames
  },
  RENTED: {
    name: 'RENTED',
    residentialLabel: 'Rented (last %LISTING_VISIBILITY%)',
    commercialLabel: 'Leased (last %LISTING_VISIBILITY%)',
    digitalDataKey: 'Rented',
    urlSlug: 'rented',
    listingTypes: _listingType.RentListingTypeNames
  }
};
var getPropertyStatusForType = listingType => (0, _values.default)(PropertyStatus).filter(each => each.listingTypes.includes(listingType));
exports.getPropertyStatusForType = getPropertyStatusForType;
var _default = exports.default = PropertyStatus;